import {
  createFeatureSelector,
  createReducer,
  createSelector,
  on,
} from '@ngrx/store';
import { login, logout } from './auth.actions';

export interface IAuthSlice {
  status: 'authorized' | 'unauthorized';
}

export interface IAuthActions {
  type: '[Auth API] Login Success' | '[Auth API] Logout Success' | string;
}

export const initialState: IAuthSlice = {
  status: 'unauthorized',
};

const _authReducer = createReducer(
  initialState,
  on(login, (state) => {
    console.log('loginAction');
    return { ...state, status: 'authorized' };
  }),
  on(logout, (state) => {
    localStorage.clear();
    location.replace('/auth');

    return { ...state, status: 'unauthorized' };
  })
);

export function authReducer(
  state: IAuthSlice | undefined,
  action: IAuthActions
) {
  return _authReducer(state, action);
}

export const selectAuthStatus = createSelector(
  createFeatureSelector<IAuthSlice>('auth'),
  (auth) => auth.status
);
